export default function Reports() {
  return <div>Report</div>;
}
